module.exports = __webpack_public_path__ + "static/p05_pollito02-d48b2c31e54da7e0cf6b58cc6dc4e38b.png";